module.exports = __webpack_public_path__ + "sx.svg?6c22419aeaf5deb9ca0cd85368de24bd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sx.svg
// module id = 1631
// module chunks = 0